exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-filters[data-v-757e8145]{float:left;width:100%;background:#f5f8f9}.card-deck .card[data-v-757e8145]{margin:0}.filter-container[data-v-757e8145]{padding:10px 0}.filter-container label[data-v-757e8145]{color:#fff;font-weight:700}.panel .panel-body[data-v-757e8145]{padding:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-757e8145","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/jobs/JobsPage.vue
// module id = bLx2
// module chunks = 0